export const DELETED_DATA_OPACITY_FACTOR = 0.3

export const BUFFER_PANE = "data-buffers";
export const BUFFER_PANE_Z_INDEX = 450;